import { useCallback } from 'react';
import { useAuthFetch } from '../AuthComponent';

/** JSON client for /api/rfid/*. `useAuthFetch` adds the JWT and `?store=`;
 *  this adds `shopify_location_id`, JSON-encodes bodies and throws `detail`. */
export function useRfidApi(shopifyLocationId) {
  const authFetch = useAuthFetch();
  return useCallback(async (path, { method = 'GET', body } = {}) => {
    let url = path;
    if (shopifyLocationId && !/[?&]shopify_location_id=/.test(url)) {
      url += `${url.includes('?') ? '&' : '?'}shopify_location_id=${encodeURIComponent(shopifyLocationId)}`;
    }
    const opts = { method };
    if (body !== undefined) {
      opts.headers = { 'Content-Type': 'application/json' };
      opts.body = JSON.stringify(body);
    }
    const r = await authFetch(url, opts);
    const data = await r.json().catch(() => ({}));
    if (!r.ok) {
      // FastAPI 422 sends `detail` as an array of objects; always throw a string.
      const d = data.detail;
      const msg = typeof d === 'string' ? d
        : Array.isArray(d) ? d.map(m => (m && m.msg) || JSON.stringify(m)).join('; ')
        : d ? JSON.stringify(d) : `${method} ${path} failed (${r.status})`;
      throw new Error(msg);
    }
    return data;
  }, [authFetch, shopifyLocationId]);
}
